import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentPreviewComponent } from './document-preview.component';

@NgModule({
  declarations: [DocumentPreviewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule
  ],
  exports: [DocumentPreviewComponent]
})
export class DocumentPreviewModule {
  customElementComponent: Type<any> = DocumentPreviewComponent;
}
